export const userRoles = ['super_admin', 'admin', 'member'] as const;
